export default __webpack_public_path__ + "static/media/sv22_kr_head_a1.8e106c6a.mp3";